// import Fb from 'assets/icons/fb.svg';
import Twit from 'assets/icons/twit.svg';
import In from 'assets/icons/in.svg';
// import Insta from 'assets/icons/insta.svg';
const SOCIAL_LINKS = [
  // { name: 'facebook', icon: Fb, link: 'https://www.facebook.com/' },
  { name: 'twitter', icon: Twit, link: 'https://twitter.com/cap60data' },
  // { name: 'instagram', icon: Insta, link: 'https://www.instagram.com/' },
  {
    name: 'linkedin',
    icon: In,
    link: 'https://www.linkedin.com/company/cap60/',
  },
];
export default SOCIAL_LINKS;
